/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterInstanceFleetProvisioningSpecifications } from './emrClusterInstanceFleetProvisioningSpecifications';
import { EmrClusterInstanceFleetStatus } from './emrClusterInstanceFleetStatus';
import { EmrClusterInstanceTypeSpecification } from './emrClusterInstanceTypeSpecification';


export interface EmrClusterInstanceFleet { 
    /**
     * The unique identifier of the instance fleet
     */
    id?: string;
    /**
     * The friendly name of the instance fleet
     */
    name?: string;
    /**
     * The node type that the instance fleet hosts. Valid values are MASTER,CORE,and TASK
     */
    instanceFleetType?: string;
    /**
     * The target capacity of On-Demand units for the instance fleet, which determines how many On-Demand instances to provision. When                   the instance fleet launches, Amazon EMR tries to provision On-Demand instances as specified by InstanceTypeConfig. Each instance configuration                   has a specified WeightedCapacity. When an On-Demand instance is provisioned, the WeightedCapacity units count toward the target capacity.                   Amazon EMR provisions instances until the target capacity is totally fulfilled, even if this results in an overage. For example, if there are                   2 units remaining to fulfill capacity, and Amazon EMR can only provision an instance with a WeightedCapacity of 5 units, the instance is                   provisioned, and the target capacity is exceeded by 3 units.                   NOTE: If not specified or set to 0, only Spot instances are provisioned for the instance fleet using TargetSpotCapacity. At least one of                   TargetSpotCapacity and TargetOnDemandCapacity should be greater than 0. For a master instance fleet, only one of TargetSpotCapacity and                   TargetOnDemandCapacity can be specified, and its value must be 1.                
     */
    targetOnDemandCapacity?: number;
    /**
     * The target capacity of Spot units for the instance fleet, which determines how many Spot instances to provision. When the                   instance fleet launches, Amazon EMR tries to provision Spot instances as specified by InstanceTypeConfig. Each instance configuration has a                   specified WeightedCapacity. When a Spot instance is provisioned, the WeightedCapacity units count toward the target capacity. Amazon EMR                   provisions instances until the target capacity is totally fulfilled, even if this results in an overage. For example, if there are 2 units                   remaining to fulfill capacity, and Amazon EMR can only provision an instance with a WeightedCapacity of 5 units, the instance is provisioned,                   and the target capacity is exceeded by 3 units.                   NOTE: If not specified or set to 0, only On-Demand instances are provisioned for the instance fleet. At least one of TargetSpotCapacity and                   TargetOnDemandCapacity should be greater than 0. For a master instance fleet, only one of TargetSpotCapacity and TargetOnDemandCapacity can be                   specified, and its value must be 1.                
     */
    targetSpotCapacity?: number;
    /**
     * The number of On-Demand units that have been provisioned for the instance fleet to fulfill TargetOnDemandCapacity.                
     */
    provisionedOnDemandCapacity?: number;
    /**
     * The number of Spot units that have been provisioned for this instance fleet to fulfill TargetSpotCapacity                
     */
    provisionedSpotCapacity?: number;
    instanceFleetStatus?: EmrClusterInstanceFleetStatus;
    /**
     * The instance type configurations that define the EC2 instances in the instance fleet
     */
    instanceTypeSpecifications?: Array<EmrClusterInstanceTypeSpecification>;
    launchSpecifications?: EmrClusterInstanceFleetProvisioningSpecifications;
}
